/* exported FwdVmail, AudioPlayer, NSContactSearch, NSDomainSettings, ModuleTemplate */
/* global subDomain, subUser, vmailForward, statMetadata,
 loadModal, Storages */
/** *************************************************************************
 ***************************************************************************
 *
 * NETSAPIENS OMP MODULES
 *
 ***************************************************************************
 ***************************************************************************
 *
 * Name each module by capitalizing the first letter (e.g. NewModule).
 *
 * Settings are assigned to {s} to provide access to commonly used settings
 * throughout the module.
 *
 * All require jquery.js, bootstrap.js, and scripts.js
 *
 ************************************************************************** */

// add IE support for trim()
if (typeof String.prototype.trim !== 'function') {
  // eslint-disable-next-line no-extend-native
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

var NSModal = (function () {
  /* checks if modal is currently visible */
  var isModalVisible = function () {
    if ($('.modal').hasClass('in')) {
      return true;
    }

    return false;
  };

  /**
   * LOAD MODAL
   * This module loads a modal via ajax. It loads the content and shows the modal.
   * Currently does not work well.
   *
   * @requires bootstrap.js
   * @returns {object} public entries to init and update methods.
   */

  var LoadModal = (function () {
    var addModalHtml = function ($modal, html) {
      $modal.contents(':not(.loading-mask)').remove();
      $modal.find('.modal-content').html(html);
    };

    var loadPath = function ($modal, path, callback) {
      $.ajax({
        url: path,
        cache: false
      })
        .done(function (html) {
          addModalHtml($modal, html);

          if (callback) {
            callback();
          }
        })
        .fail(function (textStatus) {
          $modal.modal('loading');
          $modal.addClass('load-failed');

          var html = `<div class="modal-dialog modal-md" role="dialog" tabindex="-1">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button"
                    class="btn btn-primary close cancel"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onclick="hideModal('${$modal[0]}');">&times;
            </button>
            <h4>${textStatus.statusText}</h4>
        </div>
        <div class="modal-body">
            <div class="load-failed">
                <h4>${_('Contents failed to load.')}</h4>
                <h4>${_('Please try again.')}</h4>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button"
                    class="cancel btn btn-default"
                    data-dismiss="modal"
                    onclick="hideModal('${$modal[0]}');">${_('Close')}
            </button>
        </div>
    </div>
</div>`;

          $modal.html(html);
        });
    };

    var init = function (modalId, path) {
      log(path);

      $('.helpsy').tooltip('hide');

      var $modal = $(modalId);

      var initCallback = function () {
        $modal.modal();
      };

      // create the backdrop and wait for next modal to be triggered
      $('body').modalmanager('loading');

      setTimeout(function () {
        loadPath($modal, path, initCallback);
      }, 1000);
    };

    var update = function (modalId, path) {
      var $modal = $(modalId);
      var updateCallback = function () {
        $modal
          .modal('loading')
          .find('.modal-body')
          .prepend('<div class="alert alert-info fade in">'
            + 'Updated!<button type="button" class="close" data-dismiss="alert">&times;</button>'
            + '</div>');
      };

      $modal.modal('loading');

      setTimeout(function () {
        loadPath($modal, path, updateCallback);
      }, 1000);
    };

    /**
     * public methods
     */
    return {
      init: init,
      update: update
    };
  }());

  return {
    isModalVisible: isModalVisible,
    LoadModal: LoadModal
  };
}());

/**
 * FORWARD VOICEMAIL
 * This module forwards voicemail to another on-net user. Used in either
 * the user homepage or messages index.
 *
 * @returns {object} public entry to init method.
 */
var FwdVmail = (function () {
  /**
   * local settings variables accessible across module methods
   */
  var settings = {
    fwdBtn: null, // assigned on init
    fwdMsgBtn: null, // assigned after popover creation
    fwdMsgFld: null, // assigned after popover creation
    filename: null, // assigned in bindUIActions
    folder: null, // assigned in bindUIActions
    fwdPopover: `<div class="input-group">
    <input class="form-control forward-msg-field" placeholder="${_('Enter a user or extension')}" type="text" />
    <span class="input-group-btn">
        <button class="btn btn-default forward-msg-btn" type="button" title="${_('Forward')}">
            <i class="glyphicon glyphicon-arrow-right"></i>
        </button>
    </span>
</div>`,
    fwdTemplate: `<div class="popover forward-popover" role="tooltip">
    <div class="arrow"></div>
    <div class="popover-inner">
        <div class="popover-content"></div>
    </div>
</div>`,
  };

  /**
   * builds the forward popover
   * TODO: make generic buildPopover widget
   */
  var buildPopover = function (selector, options) {
    options = Object.assign({
      html: true,
      placement: 'left',
      template: settings.fwdTemplate,
      content: settings.fwdPopover,
      sanitize: false,
    }, options);

    if (options.container != null) {
      var rowId = $(options.container)
        .closest('tr')
        .attr('id');

      options.container = `#${rowId} ${options.container}`;
    }

    settings.fwdBtn.popover(options);
  };

  /**
   * bind forward actions - binds the post forward action to the popover forward button
   *
   */
  var bindFwdActions = function () {
    settings.fwdMsgBtn.off('click');
    settings.fwdMsgBtn.on('click', function () {
      var forward = $(this)
        .closest('.input-group')
        .find('.forward-msg-field')
        .val();

      if (forward === '') {
        jsFlash('Voicemail was not forwarded!', 'danger');
      } else {
        settings.fwdMsgBtn.prop('disabled', true);

        $.post(
          '/portal/voicemails/forward/',
          {
            user: subUser,
            domain: subDomain,
            type: encodeURI(settings.folder),
            filename: settings.filename,
            forward_to: forward
          }
        )
          .done(function () {
            jsFlash(`Voicemail has been forwarded to ${forward}`, 'success');
            settings.fwdBtn.popover('hide');
            settings.fwdBtn.attr('style', '');
          })
          .fail(function (xhr) {
            var data = JSON.parse(xhr.responseText);
            var message = data && data.message
              ? data.message
              : 'Voicemail was not forwarded!';

            settings.fwdMsgBtn.prop('disabled', false);
            jsFlash(message, 'danger');
          });
      }
    });

    settings.fwdMsgFld.on('keyup', function (e) {
      if (e.which == 13) {
        settings.fwdMsgBtn.trigger('click');
      }
    });
  };

  var init = function (selector, options) {
    options = options || {};
    settings.fwdBtn = $(selector);

    settings.fwdBtn
      .on('click', function (event) {
        var currentFwdBtn = $(this);
        var currentRow = currentFwdBtn.closest('tr');

        if (event.preventDefault !== undefined) {
          event.preventDefault();
        }

        settings.filename = currentRow.data('filename');
        settings.folder = currentRow.data('folder');

        buildPopover(selector, options);

        currentFwdBtn.css('visibility', 'visible');

        currentFwdBtn.popover('show');

        // vmailForward defined by autocomplete helper
        if (typeof vmailForward !== 'undefined') {
          vmailForward();
        }

        $('body').on('click.fwdVmail', function (e) {
          var $target = $(e.target);

          // did not click a popover toggle, or icon in popover toggle, or popover
          if (!$target.hasClass('forward-btn')
            && !$target.parent().hasClass('forward-btn')
            && $target.parents('.popover.in').length === 0
          ) {
            settings.fwdBtn.popover('hide', function () {
              settings.fwdBtn.popover('destroy');
              settings.fwdBtn.attr('style', '');
            });

            $('body').off('click.fwdVmail');
          }
        });
      })
      .on('shown.bs.popover', function () {
        settings.fwdMsgBtn = $('.forward-msg-btn');
        settings.fwdMsgFld = $('.forward-msg-field');
        settings.fwdMsgFld.trigger('focus');

        bindFwdActions();
      });
  };

  /**
   * public methods
   */
  return {
    init: init
  };
}());

/**
 * Create duplicate endpoint in a another domain
 *
 * @returns {object} public entry to init method.
 **/

var CopyEndpoint = (function () {

  /**
   * local settings variables accessible across module methods
   */
  var settings = {
    allFwdBtn: null,    //assigned on init
    fwdMsgBtn: null,    //assigned after popover creation
    fwdMsgFld: null,    //assigned after popover creation
    fwdBtn: null,       //assigned in bindUIActions
    filename: null,     //assigned in bindUIActions
    folder: null,       //assigned in bindUIActions
    fwdPopover: `<div class="input-append"><input id="copy-endpoint-field" type="text" placeholder="${_('Enter a Domain')}">
    <button id="copy-endpoint-btn" class="btn copy-endpoint-send" type="button" title="${_('Copy To')}">
        <i class="icon-arrow-right"></i>
    </button>
</div>`,
    fwdTemplate: `<div class="popover forward-popover">
    <div class="arrow"></div>
    <div class="popover-inner">
        <div class="popover-content"><p></p></div>
    </div>
</div>`,
  };

  var init = function () {
      settings.allFwdBtn = $('.endpoint-copy');

      buildPopover();
      bindUIActions();
    },

    /**
     * builds the forward popover
     * TODO: make generic buildPopover widget
     */
    buildPopover = function () {
      settings.allFwdBtn.popover({
        html: true,
        placement: 'left',
        template: settings.fwdTemplate,
        content: settings.fwdPopover,
      });
    },

    /**
     * binds initial ui interactions
     */
    bindUIActions = function () {
      settings.allFwdBtn.on('click', function () {

        settings.fwdMsgBtn = $('#copy-endpoint-btn');
        settings.fwdMsgFld = $('#copy-endpoint-field');
        settings.fwdBtn = $(this);
        settings.address_id = $(this)
          .parent()
          .parent()[0].getElementsByTagName('td')[0].getAttribute('address_id');
        settings.original_domain = $(this)
          .parent()
          .parent()[0].getElementsByTagName('td')[1].getAttribute('domain');

        settings.fwdBtn.css('visibility', 'visible');
        settings.fwdMsgFld.focus();

        // vmailForward defined by autocomplete helper
        if (typeof endpointCopy != 'undefined') {
          endpointCopy();
        }

        bindFwdActions();
      });

      $('body').on('click.closeVmFwd', function (e) {
        // did not click a popover toggle, or icon in popover toggle, or popover
        if ($(e.target).data('toggle') !== 'popover'
          && $(e.target).parents('.popover.in').length === 0
        ) {
          settings.allFwdBtn.popover('hide');
          settings.allFwdBtn.attr('style', '');
        }
      });
    },

    /**
     * bind forward actions - binds the post forward action to the popover forward button
     *
     **/
    bindFwdActions = function () {
      settings.fwdMsgBtn.off('click');
      settings.fwdMsgBtn.on('click', function () {

        var forward = settings.fwdMsgFld.val();

        if (forward === '') {
          jsFlash('Endpoint was not copied!', 'danger');
        } else {
          settings.fwdMsgBtn.prop('disabled', true);

          $.post(`/portal/inventory/copyEndpoint/${settings.address_id}/${settings.original_domain}/${forward}`, $.noop)
            .done(function () {
              jsFlash('Endpoint was copied to ' + forward, 'success');
              settings.allFwdBtn.popover('hide');
              settings.fwdBtn.attr('style', '');
              // reload the page to show the new endpoint
              location.reload(true);
            })
            .fail(function () {
              jsFlash('Endpoint was not copied!', 'danger');
              settings.fwdMsgBtn.prop('disabled', false);
            });
        }
      });

      settings.fwdMsgFld.on('keyup', function (e) {
        if (e.which === 13) {
          settings.fwdMsgBtn.trigger('click');
        }
      });
    };

  /**
   * public methods
   */
  return {
    init: init
  };
})();

/**
 * STATS GRID SETTINGS
 * This module loads, saves and builds the call center stat grid settings in the call center
 * homepage
 *
 * @requires bootstrap.js
 * @requires bootstrap-switch.js
 * @requires jquery.storageapi.js
 * @returns {object} public entry to init method.
 */
var StatsGridSettings = (function () {
  /**
   * local settings variables accessible across module methods
   */
  var s = {
    settings: null,
    storage: null
  };

  /**
   * save settings to local storage
   *
   * @param {object} settings is an object with all the stats grid settings
   */
  var saveLocalSettings = function (settings) {
    log('Stats Grid Settings: saving settings to local storage.');

    s.settings = settings;

    var json = JSON.stringify(settings);

    s.storage.set('statsGridSettings', json);
  };

  /**
   * default settings if nothing exists
   *
   * @returns {object} settings is an object with all the default stats grid settings
   */
  var defaultSettings = function () {
    return [
      {
        id: 'callersWaiting',
        title: _('Callers Waiting'),
        settingTitle: _('Callers Waiting'),
        description: _('The amount of callers waiting in the queue.'),
        abbr: 'CW',
        show: true,
        values: {
          upper: 5,
          lower: ''
        }
      },
      {
        id: 'averageWait',
        title: _('Average Wait Time'),
        settingTitle: _('Average Wait Time (sec)'),
        description: _(
          'The average time a caller waits in the queue before the call is either answered or they hang up.'
        ),
        abbr: 'AWT',
        show: true,
        values: {
          upper: 60,
          lower: ''
        }
      },
      {
        id: 'averageHandling',
        title: _('Average Handling Time'),
        settingTitle: _('Average Handling Time') + ' (' + _('sec') + ')',
        description: _('The average of talk time, hold time and disposition time combined.'),
        abbr: 'AHT',
        show: true,
        values: {
          upper: 240,
          lower: ''
        }
      },
      {
        id: 'serviceLevel',
        title: _('Service Level'),
        settingTitle: _('Service Level') + '(%)',
        description: _('The ratio of calls meeting the configurable service level agreement.'),
        abbr: 'SL',
        invert: 'yes',
        show: false,
        values: {
          upper: 75,
          lower: ''
        }
      },
      {
        id: 'abandonRate',
        title: _('Abandon Rate'),
        settingTitle: _('Abandon Rate') + '(%)',
        description: _('The ratio of abandoned calls to calls offered.'),
        abbr: 'ABN',
        show: true,
        values: {
          upper: 15.0,
          lower: ''
        }
      },
      {
        id: 'callsAnswered',
        title: _('Calls Answered'),
        settingTitle: _('Calls Answered'),
        description: _('Total calls answered.'),
        abbr: 'CA',
        show: true,
        values: {
          upper: '',
          lower: ''
        }
      },
      {
        id: 'callVolume',
        title: _('Call Volume'),
        settingTitle: _('Call Volume'),
        description: _(
          'Overall calls, including calls that never made it all the way through a auto attendant.'
        ),
        abbr: 'CV',
        show: true,
        values: {
          upper: '',
          lower: ''
        }
      },
      {
        id: 'abandonedCalls',
        title: _('Abandoned Calls'),
        settingTitle: _('Abandoned Calls'),
        description: _('Calls that abandoned the queue before being dispatched to an agent.'),
        abbr: 'AC',
        show: false,
        values: {
          upper: 10,
          lower: ''
        }
      }
    ];
  };

  /**
   * get settings from local storage, returns json
   *
   * @returns {object} localSettings is settings from local storage or the default settings object
   */
  var loadLocalSettings = function () {
    var localSettings;

    if (s.storage.isSet('statsGridSettings')) {
      // .get() converts json to js object
      localSettings = s.storage.get('statsGridSettings');
    } else {
      localSettings = defaultSettings();
    }

    return localSettings;
  };

  /**
   * reset settings to default and rebuild stats grid settings html
   */
  var resetSettings = function () {
    log('Stats Grid Settings: Resetting stats grid settings.');

    s.storage.remove('statsGridSettings');

    // eslint-disable-next-line no-use-before-define
    rebuildHtml();
    // eslint-disable-next-line no-use-before-define
    StatsGrid.rebuild();
  };

  /**
   * binds events to stats grid setting buttons. initializes popovers and switches
   */
  var bindUIActions = function () {
    // edit json on changes to fields, switches
    $('#stats-grid-form .label-popover').popover({
      trigger: 'hover',
      template: '<div class="popover"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"><p></p></div></div></div>',
      container: 'body',
      html: true,
      sanitize: false,
      delay: { show: 200, hide: 0 }
    });

    $('#stats-grid-form .checkbox-switch').bootstrapSwitch({
      onColor: 'success',
      onSwitchChange: function (e, state) {
        log('switch changed to: ' + state);

        var target = $(e.target).data('target');

        $(target).collapse('toggle');
      },
      onText: _('On'),
      offText: _('Off'),
    });

    $('#reset-grid-settings').on('click', function () {
      resetSettings();
    });
  };

  /**
   * appends stats grid settings html to the form
   *
   * @param {string} html is the stats grid settings html
   */
  var appendHtml = function (html) {
    $('#stats-grid-form').append(html);

    bindUIActions();
  };

  /**
   * build form fields html with settings
   */
  var buildHtml = function () {
    s.settings = loadLocalSettings();

    var html = '<div class="accordion" id="stats-grid-accordion">';
    var propUndefined = false;

    $.each(s.settings, function (i, setting) {
      // test object properties to see if they exist in settings
      $.each(
        ['id', 'title', 'settingTitle', 'description', 'abbr', 'show', 'values'],
        function (index, prop) {
          if (typeof setting[prop] === 'undefined') {
            log('Stats Grid Settings: Found an undefined property in stats grid settings!');

            propUndefined = true;

            return false;
          }

          return true;
        }
      );

      if (!propUndefined) {
        var checked = '';
        var collapse = '';

        if (setting.show) {
          checked = 'checked';
          collapse = 'in';
        }

        if (setting.id == 'serviceLevel') {
          html += '<div class="panel panel-default stats-grid-setting"'
            + ' data-grid-stat-id="' + setting.id
            + '" data-grid-stat-title="' + setting.title
            + '" data-grid-stat-setting-title="' + setting.settingTitle
            + '" data-grid-stat-abbr="' + setting.abbr + '">'
            + '<div class="panel-heading">'
            + '<span class="accordion-no-toggle stats-grid-toggle">'
            + '<span class="label-popover" data-content="' + setting.description + '">'
            + setting.settingTitle
            + ' <i class="glyphicon glyphicon-info-sign"></i></span>'
            + '<input type="checkbox" name="' + setting.id + '-checkbox"'
            + ' data-toggle="collapse"'
            + ' data-target="#' + setting.id
            + '" class="checkbox-switch" ' + checked + '> '
            + '</span>'
            + '</div>'
            + '<div id="' + setting.id + '" class="panel-body collapse ' + collapse + '">'
            + '<div class="row">'
            + '<div class="col-xs-6">'
            + '<div class="form-group">'
            + '</div>'
            + '</div>'
            + '<div class="col-xs-6">'
            + '<div class="form-group">'
            + '<label class="label-popover" data-content="'
            + _(
              'When the stat turns completely red. Higher number on this stat is better, so this is a lower limit.'
            ) + '">'
            + _('Threshold')
            + ' <i class="glyphicon glyphicon-info-sign"></i></label>'
            + '<div class="form-group">'
            + '<input type="text"'
            + ' name="' + setting.id + '-upper"'
            + ' class="form-control"'
            + ' placeholder=""'
            + ' value="' + setting.values.upper + '"> '
            + '<span class="help-block text-muted"></span></div></div></div></div></div></div>';
        } else {
          html += '<div class="panel panel-default stats-grid-setting"'
            + ' data-grid-stat-id="' + setting.id
            + '" data-grid-stat-title="' + setting.title
            + '" data-grid-stat-setting-title="' + setting.settingTitle
            + '" data-grid-stat-abbr="' + setting.abbr + '">'
            + '<div class="panel-heading">'
            + '<span class="accordion-no-toggle stats-grid-toggle">'
            + '<span class="label-popover" data-content="' + setting.description + '">'
            + setting.settingTitle
            + ' <i class="glyphicon glyphicon-info-sign"></i></span>'
            + '<input type="checkbox" name="' + setting.id + '-checkbox" data-toggle="collapse"'
            + ' data-target="#' + setting.id
            + '" class="checkbox-switch" ' + checked + '> '
            + '</span>'
            + '</div>'
            + '<div id="' + setting.id + '" class="panel-body collapse ' + collapse + '">'
            + '<div class="row">'
            + '<div class="col-xs-6">'
            + '<div class="form-group">'
            + '<label class="label-popover" data-content="'
            + _(
              'When the stat turns completely yellow. Should be less than the Upper Threshold. If left blank, color will turn yellow at 70% of Upper Threshold.'
            ) + '">'
            + _('Lower Threshold')
            + ' <i class="glyphicon glyphicon-info-sign"></i></label>'
            + '<input type="text"'
            + ' name="' + setting.id + '-lower"'
            + ' class="form-control"'
            + ' placeholder=""'
            + ' value="' + setting.values.lower + '"> '
            + '<span class="help-block text-muted"></span>'
            + '</div>'
            + '</div>'
            + '<div class="col-xs-6">'
            + '<div class="form-group">'
            + '<label class="label-popover" data-content="'
            + _('When the stat turns completely red. Should be more than the Lower Threshold.') + '">'
            + _('Upper Threshold')
            + ' <i class="glyphicon glyphicon-info-sign"></i></label>'
            + '<input type="text" name="' + setting.id + '-upper" class="form-control" placeholder=""'
            + ' value="' + setting.values.upper + '"> '
            + '<span class="help-block text-muted"></span>'
            + '</div>'
            + '</div>'
            + '</div>'
            + '</div>'
            + '</div>';
        }
      } else {
        return false;
      }

      return true;
    });

    if (!propUndefined) {
      html += '</div>';

      appendHtml(html);
    } else {
      resetSettings();
    }
  };

  /**
   * remove settings html and build new html.
   */
  var rebuildHtml = function () {
    $('#stats-grid-form').empty();

    buildHtml();
  };

  /**
   * update settings with settings form field values
   *
   * @returns {object} settings is an object with all the stats grid settings
   */
  var collectSettings = function () {
    log('Stats Grid Settings: collecting settings from fields.');

    var settings = loadLocalSettings();

    $('.stats-grid-setting').each(function () {
      var id = $(this).data('grid-stat-id');
      var show = $('[name=\'' + id + '-checkbox\']').prop('checked');
      var upper = $('[name=\'' + id + '-upper\']').val();
      var lower = $('[name=\'' + id + '-lower\']').val();

      if (lower == null) {
        lower = upper;
      }

      // remove everything but digits and decimals
      if (upper !== '') {
        upper = parseFloat(upper.replace(/[^0-9.]/g, ''));
      }

      if (lower !== '') {
        lower = parseFloat(lower.replace(/[^0-9.]/g, ''));
      }

      if (lower === null) {
        lower = '';
      }

      if (upper === null) {
        upper = '';
      }

      if (lower > upper) {
        upper = lower;
      }

      $.each(settings, function (i) {
        if (settings[i].id == id) {
          settings[i].show = show;
          settings[i].values.upper = upper;
          settings[i].values.lower = lower;

          return false;
        }

        return true;
      });
    });

    return settings;
  };

  /**
   * collect and save settings to local
   *
   */
  var saveNewSettings = function () {
    var newSettings = collectSettings();

    saveLocalSettings(newSettings);
  };

  /**
   * initializes the stats grid settings. assigns local storage and starts building html
   */
  var init = function () {
    s.storage = Storages.localStorage;

    buildHtml();
  };

  /**
   * public methods
   */
  return {
    init: init,
    rebuild: rebuildHtml,
    load: loadLocalSettings,
    save: saveNewSettings
  };
}());

/**
 * STATS GRID
 * This module builds a call center stats grid using settings from StatsGridSettings.
 * By default, stats are refreshed in an interval of 60 seconds, except for the callers waiting
 *
 * @requres StatsGridSettings
 * @returns public entry to init method.
 */
var StatsGrid = (function () {
  /**
   * local settings variables accessible across module methods
   */
  var s = {
    settings: null,
    queue: null
  };

  /**
   * shows an alert at the top of the stats grid
   *
   * @param {string} msg is the message text to show in the alert
   */
  var gridAlert = function (msg) {
    var statsBody = $('#dash-stats-body');
    var html = '<div class="alert">'
      + '<button type="button" class="close" data-dismiss="alert">&times;</button>'
      + msg
      + '</div>';

    statsBody.prepend(html);
  };

  /**
   * totals the number of callers waiting and updates the stat in the stats grid
   *
   * @param {string} stat is the object for an individual stat
   * @returns {string} html is the table html for an individual stat in the stats grid
   */
  var statHtml = function (stat) {
    log(stat);

    var desc = '';
    var subDesc = '';

    if (typeof stat.invert === 'undefined') {
      stat.invert = 'no';
    }

    var help = '';

    if (statMetadata[stat.abbr] != null) {
      desc = statMetadata[stat.abbr].description;

      if (statMetadata[stat.abbr].sub_description != null) {
        subDesc = statMetadata[stat.abbr].sub_description;
      }

      help = '<span class="label-popover popover-stats"'
        + ' data-title="' + statMetadata[stat.abbr].title + '"'
        + '  data-content="' + desc;

      if (subDesc) {
        help += '<p class=\'text-muted\'><small>' + subDesc + '</small></p>';
      }

      help += '"><i class="glyphicon glyphicon-info-sign"></i></span>';
    }

    return '<table class="dash-stats-grid-table">'
      + '<tbody>'
      + '<tr class="dash-stats-label-row">'
      + '<td title="' + stat.title + '">' + stat.abbr + ' ' + help + '</td>'
      + '</tr>'
      + '<tr class="dash-stats-data-row">'
      + '<td id="dash-stats-grid-' + stat.abbr.toLowerCase() + '"'
      + ' data-grid-invert="' + stat.invert + '"'
      + ' data-grid-stat="' + stat.abbr + '"'
      + ' data-grid-stat-upper-limit="' + stat.values.upper + '"'
      + ' data-grid-stat-lower-limit="' + stat.values.lower + '"></td>'
      + '</tr>'
      + '</tbody>'
      + '</table>';
  };

  /**
   * calulates the stat color based on percent of threshold
   *
   * @param {number} pct is the percent of the stat value versus the threshold
   * @param {object} pctColors is an object of colors with associated percents
   */
  var getPctColor = function (pct, pctColors) {
    var arrayLength = pctColors.length;
    var lastColors;

    if (pct > pctColors[arrayLength - 1].pct) {
      lastColors = pctColors[arrayLength - 1];

      return 'rgb('
        + [lastColors.color.r, lastColors.color.g, lastColors.color.b].join(',')
        + ', 0.6)';
    }

    if (pct === 0) {
      lastColors = pctColors[0];

      return 'rgb('
        + [lastColors.color.r, lastColors.color.g, lastColors.color.b].join(',')
        + ', 0.6)';
    }

    for (var i = 0; i < arrayLength; i += 1) {
      if (pct <= pctColors[i].pct) {
        var lower = pctColors[i - 1];
        var upper = pctColors[i];
        var range = upper.pct - lower.pct;
        var rangePct = (pct - lower.pct) / range;
        var pctLower = 1 - rangePct;
        var pctUpper = rangePct;
        var color = {
          r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
          g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
          b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
        };

        return 'rgb(' + [color.r, color.g, color.b].join(',') + ', 0.6)';
        // or output as hex if preferred
      }
    }

    return null;
  };

  /**
   * creates the colors object that matches color to a percent value.
   *
   * @param {number} lowerLimitPct is the percent calculated from
   * the lower threshold and upper threshold
   *
   * @returns {object} pctColors is an object of colors with associated percents
   */
  var setColorObj = function (lowerLimitPct) {
    var pctColors;

    if (typeof lowerLimitPct === 'undefined' || !lowerLimitPct || lowerLimitPct >= 1.0) {
      lowerLimitPct = 0.7;
    }

    pctColors = [
      { pct: 0.0, color: { r: 0x00, g: 0xff, b: 0 } },
      { pct: lowerLimitPct, color: { r: 0xff, g: 0xff, b: 0 } },
      { pct: 1.0, color: { r: 0xff, g: 0x00, b: 0 } }
    ];

    return pctColors;
  };

  /**
   * changes the stat color background based on the current value and its ratio to the thresholds
   *
   * @param {string} statId is the object for an individual stat
   * @param {number} val is the object for an individual stat
   */
  var changeStatColor = function (statId, val) {
    var pct = 0;
    var upperLimit = $('#' + statId).data('grid-stat-upper-limit');
    var lowerLimit = $('#' + statId).data('grid-stat-lower-limit');
    var lowerLimitPct;
    var invert = false;

    if ($('#' + statId).data('grid-invert') == 'yes') {
      invert = true;
    }

    if (!upperLimit && !lowerLimit) {
      $('#' + statId).css({
        border: '1px solid #eee',
        'box-sizing': 'border-box',
        '-moz-box-sizing': 'border-box',
        '-webkit-box-sizing': 'border-box'
      });
    } else {
      val = parseFloat(val);
      lowerLimitPct = lowerLimit / upperLimit;

      if (invert) {
        if (upperLimit && 100 - val !== 0) {
          pct = (100 - val) / (100 - upperLimit);
        } else {
          pct = 0;
        }
      } else if (upperLimit && val !== 0) {
        // if there is no upper limit, use lowerlimit for percent
        pct = val / upperLimit;
      } else if (lowerLimit) {
        pct = val / lowerLimit;
      } else {
        pct = 0;
      }

      if (invert) {
        log(statId + pct);
      }

      var pctColors = setColorObj(lowerLimitPct);
      var color = getPctColor(pct, pctColors);

      $('#' + statId).animate({
        backgroundColor: color
      }, 200);
    }
  };

  /**
   * totals the number of callers waiting and updates the stat in the stats grid
   */
  var cwSum = function () {
    log('Stats Grid: calculating callers waiting');

    var statId = 'dash-stats-grid-cw';
    var value;
    var sum = 0;

    // iterate through each td based on class and add the values
    if (Storages.localStorage.get('statsGridQueueCheckedCount') > 1
      || (Storages.localStorage.isSet('statsGridQueueChecked')
        && Storages.localStorage.get('statsGridQueueChecked') != null)
    ) {
      $('#manager_queues .graph-checkbox').each(function () {
        if ($(this).is(':checked')) {
          value = $(this).parent()
            .parent()
            .find('.queuelength')
            .text();

          // add only if the value is number
          // eslint-disable-next-line no-restricted-globals
          if (!isNaN(value) && value.length !== 0) {
            sum += parseFloat(value);
          }
        }
      });
    } else {
      $('.queuelength').each(function () {
        value = $(this).text();

        // add only if the value is number
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(value) && value.length !== 0) {
          sum += parseFloat(value);
        }
      });
    }

    log('CW : ' + sum);
    changeStatColor(statId, sum);

    $('#' + statId).text(sum);
  };

  /**
   * updates the stats grid with stat data. colors each stat accordingly
   *
   * @param {object} data is the stats data object retrieved from loadStats
   */
  var updateGrid = function (data) {
    log('StatsGrid: updateGrid');

    var statsGridQueueChecked = Storages.localStorage.get('statsGridQueueChecked') || null;
    var statsGridQueueCheckedCount = Storages.localStorage.get('statsGridQueueCheckedCount') || null;

    $('.dash-stats-data-row td').each(function () {
      var gridStat = $(this).data('grid-stat');
      var statId = $(this).attr('id');
      var error = false;
      var val;
      var key;

      try {
        if (gridStat == 'CW') {
          cwSum();

          return true;
        }

        if (statsGridQueueChecked !== null) {
          key = statsGridQueueChecked.trim().replace(/^\|+|\|+$/g, '');

          val = parseFloat(data[key][gridStat]);
        } else {
          val = parseFloat(data['*'][gridStat]);
        }
      } catch (e) {
        log('Stats Grid: ERROR parsing data');
        log(e);
        error = true;
      }

      if (!error) {
        changeStatColor(statId, val);

        if (gridStat == 'ABN' || gridStat == 'SL') {
          val += '%';
        } else if (gridStat == 'AHT' || gridStat == 'AWT') {
          var minutes = Math.floor(val / 60);
          var seconds = val % 60;

          if (val < 60) {
            seconds = val;
          }

          val = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds);
        }
      } else {
        val = '<span title="No data">&ndash;</span>';
      }

      // set the value in the corresponding grid cell
      $(this).html(val);

      return true;
    });

    if (statsGridQueueCheckedCount !== null && statsGridQueueCheckedCount == 0) {
      $('#stats-grid-queue-label').text(_('All Queues'));
    } else if (statsGridQueueChecked !== null) {
      var statsGridQueueLabel = statsGridQueueChecked.trim().replace(/^\|+|\|+$/g, '');

      $('#stats-grid-queue-label').text(statsGridQueueLabel);
    } else if (statsGridQueueCheckedCount !== null && statsGridQueueCheckedCount > 0) {
      $('#stats-grid-queue-label')
        .text(statsGridQueueCheckedCount + ' ' + _('Queues'));
    }
  };

  /**
   * builds the stats grid table structure and then updates the grid with stat data.
   *
   * @param {object} data is the stats data object retrieved from loadStats
   */
  var buildGrid = function (data) {
    log('StatsGrid: buildGrid');

    // grab stats
    var statsBody = $('#dash-stats-body');
    var statShown = false;

    statsBody.empty();

    $.each(s.settings, function (i, stat) {
      if (stat.show) {
        var html = statHtml(stat);

        statsBody.append(html);

        statShown = true;
      }
    });

    statsBody.append('<div class="clearfix"></div>');

    if (!statShown) {
      $('#dash-stats-body').html(
        '<p class="text-muted text-center">Please select a stat to show in "settings".</p>'
      );
    } else {
      updateGrid(data);

      if (typeof $(document).popover === 'function') {
        var opts = {
          trigger: 'hover',
          placement: 'top',
          template: '<div class="popover"><div class="arrow"></div><div class="popover-inner"><h3 class="popover-title"></h3><div class="popover-content"><p></p></div></div></div>',
          container: 'body',
          html: true,
          sanitize: false,
          delay: { show: 200, hide: 0 }
        };

        $('#dash-stats-body .label-popover.popover-stats').popover(opts);
      }
    }
  };

  /**
   * loads the current stats and then updates or builds the stats grid to show them
   */
  var loadStats = function () {
    // make sure settings are the latest
    s.settings = StatsGridSettings.load();
    s.queue = null;

    var multiple = false;
    var queueSelectCount = 0;

    $('#manager_queues .graph-checkbox').each(function () {
      if ($(this).is(':checked')) {
        queueSelectCount += 1;

        if (s.queue == null) {
          s.queue = $(this).data('graph-name');
        } else {
          multiple = true;
          s.queue = s.queue + ',' + $(this).data('graph-name');
        }
      }
    });

    var url = '/portal/callqueues/statSummary?';
    var sla = Storages.localStorage.get('reports_sla_time') || 120;

    Storages.localStorage.set('statsGridQueueChecked', null);

    if (multiple) {
      url += 'queue_list=' + s.queue + '&';
    } else if (typeof s.queue !== 'undefined' && s.queue != null && s.queue != '') {
      url += 'queue=' + s.queue + '&';
      Storages.localStorage.set('statsGridQueueChecked', '|' + s.queue);
    }

    Storages.localStorage.set('statsGridQueueCheckedCount', queueSelectCount);

    if (typeof sla === 'undefined' || sla == null || sla == '') {
      sla = 60;
    }

    url += 'sla=' + sla;

    $.getJSON(url, function (data) {
      log('Stats Grid: loading stats data from ' + url);
      log(data);

      if ($('.dash-stats-grid-table').length) {
        updateGrid(data);
      } else {
        buildGrid(data);
      }
    })
      .fail(function () {
        log('Stats Grid: statsummary fail');
      })
      .always(function () {
        log('Stats Grid: statsummary complete');
      });
  };

  /**
   * grabs current stats grid settings, shows the loading animation and rebuilds the stats grid.
   */
  var reBuildGrid = function () {
    $('#dash-stats-body').html(
      '<div class="loading-container relative" style="top:0; padding: 50px 0;">'
      + '<div class="loading-spinner la-ball-spin-clockwise">'
      + '<div></div>'
      + '<div></div>'
      + '<div></div>'
      + '<div></div>'
      + '<div></div>'
      + '<div></div>'
      + '<div></div>'
      + '<div></div>'
      + '</div>'
      + '</div>'
    );

    loadStats();
  };

  /**
   * initializes the stats grid. to load stats and build the grid
   *
   * @param {integer} interval - a number in ms for the refresh interval.
   */
  var init = function (interval) {
    StatsGridSettings.init();

    s.queue = Storages.localStorage.get('statsGridQueue');

    if (typeof s.queue === 'undefined' || s.queue == 'null') {
      s.queue = null;
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof interval === 'undefined' || isNaN(interval)) {
      interval = 60000;
    }

    loadStats();

    setInterval(loadStats, interval);
  };

  /**
   * public methods
   */
  return {
    init: init,
    load: loadStats,
    rebuild: reBuildGrid,
    cw: cwSum,
    alert: gridAlert
  };
}());

/**
 * AUDIO PLAYER
 * This module builds HTML5 audio player
 *
 * @returns public entry to buildPlayer,playButton, downloadButton, and bindUIActions
 */
var AudioPlayer = (function () {
  /**
   * binds events to audio player and play button.
   *
   * @param {number} i helps identify the audio player
   */
  var bindUIActions = function (i) {
    var $audio = $('#audio-player-' + i);
    var $playtoggle = $('#playtoggle-' + i);
    var title = 'Play';

    $audio
      .on('play', function () {
        $playtoggle.tooltip('hide');
        $playtoggle.addClass('waiting');
        $playtoggle.attr('title', '');
        $playtoggle.data('original-title', _('Loading'));
      })
      .on('playing', function () {
        $playtoggle.tooltip('hide');
        $playtoggle.removeClass('waiting');
        $playtoggle.addClass('is-playing');
        $playtoggle.attr('title', '');
        $playtoggle.data('original-title', _('Stop'));
      })
      .on('pause ended', function () {
        $playtoggle.tooltip('hide');
        $playtoggle.removeClass('is-playing');
        $playtoggle.removeClass('waiting');
        $playtoggle.data('original-title', title);
        $audio[0].load();
      });

    $playtoggle.on('click', function () {
      if ($audio[0].paused) {
        $audio[0].play();
      } else {
        $audio[0].pause();
      }
    });
  };

  /**
   * builds the HTML5 audio element with source paths. combines with the playbutton.
   *
   * @param {string} path is the URL used for the source of the audio file
   * @param {integer} i is the integer to help identify the audio player
   * @param extraClasses
   * @returns {string} playHtml is the combined the play button
   */
  var playButton = function (path, i, extraClasses) {
    return `<span id="playtoggle-${i}" class="btn btn-default helpsy ${extraClasses}" title="Play">
    <i class="fa fa-play"></i>
</span>`;
  };

  /**
   * determines server name and replaces localhost with corp (for development purposes)
   */
  var checkServer = function () {
    var server = window.location.hostname;

    if (server == 'localhost') {
      server = 'corp.netsapiens.com';
    }

    return server;
  };

  /**
   * removes html characters from path and changes replaces localhost with server name
   *
   * @returns {string} path is the URL used for the source of the audio file
   */
  var cleanPath = function (path) {
    var server = checkServer();

    path = path.replace(/\b&amp;\b/g, '&');
    path = path.replace('localhost', server);

    return path;
  };

  /**
   * builds the HTML5 audio element with source paths. combines with the playbutton.
   *
   * @param {string} path is the URL used for the source of the audio file
   * @param {integer} i is the integer to help identify the audio player
   * @param {string} extraClasses is an HTML class that is passed on to the play button HTML
   * @returns {string} playerHtml is the combined audio elements and play button
   */
  var buildPlayer = function (path, i, extraClasses) {
    path = cleanPath(path);

    var ogg = path + '&convert=ogg';
    var aac = path + '&convert=aac';
    var wav = path + '&convert=signed';

    var playerHtml = `<audio id="audio-player-${i}"" preload="auto">
<source id="audio-player-${i}-wav-1" src="${wav}" type="audio/x-wav">
<source id="audio-player-${i}-wav-2" src="${ogg}" type="audio/ogg; codecs=vorbis">
<source id="audio-player-${i}-wav-3" src="${aac}" type="audio/mp4">
<source id="audio-player-${i}-aac-1" src="${aac}" type="audio/aac">
</audio>`;

    var playHtml = playButton(path, i, extraClasses);

    playerHtml += playHtml;

    return playerHtml;
  };

  /**
   * build the download button
   *
   * @param {string} path is the URL used for the source of the audio file
   * @returns {string} buttonHtml is the download button html
   */
  var downloadButton = function (path) {
    path = `${cleanPath(path)}&convert=signed`;

    return `<a class="download-audio-btn helpsy" title="Download" target="_blank" href="${path}"></a>`;
  };

  /**
   * public methods
   */
  return {
    build: buildPlayer,
    playButton: playButton,
    downloadButton: downloadButton,
    bind: bindUIActions
  };
}());

/**
 * NETSAPIENS search or sort any contacts/agents table
 *
 * @requires jquery-3.0.0.min.js
 * @returns {object} public methods
 */
var NSPresenceSearchSort = (function () {
  /**
   * Compares row data to search string
   *
   * @param {string} textfilter is the string of text that the user input to search
   * @param {object} thisRow is the row element being checked against the textfilter
   *
   * @private
   * @returns {boolean} true if it matches, false if it doesn't
   */
  var checkTextFilter = function (textfilter, thisRow) {
    if (typeof (thisRow) === 'undefined') {
      return false;
    }

    var name = thisRow.attr('name');
    var ext = thisRow.attr('uid');

    if (typeof (name) !== 'undefined') {
      if (name.toLowerCase().indexOf(textfilter.toLowerCase()) != -1) {
        return true;
      }
    }

    if (typeof (ext) !== 'undefined') {
      if (ext.indexOf(textfilter) != -1) {
        return true;
      }
    }

    return false;
  };

  /**
   * Ordering of strings in alphabetical order, except that multi-digit
   * numbers are ordered as a single character
   * http://stackoverflow.com/a/15479354
   *
   * @param {string} a - string to compare
   * @param {string} b - string to compare
   *
   * @private
   * @returns {int}
   */
  var naturalSort = function (a, b) {
    var ax = [];
    var
      bx = [];

    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
      ax.push([$1 || Infinity, $2 || '']);
    });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
      bx.push([$1 || Infinity, $2 || '']);
    });

    while (ax.length && bx.length) {
      var an = ax.shift();
      var bn = bx.shift();
      var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);

      if (nn) {
        return nn;
      }
    }

    return ax.length - bx.length;
  };

  /**
   * Compares and sorts entry based on either first name or last name, depending on type parameter
   *
   * @param {object} rows contains all of the row elements to be sorted in the table
   *
   * @private
   * @returns {object} rows is the sorted object of rows
   */
  var sortByOnline = function (rows, sortOrder) {
    // Read each row's sort keys from the DOM once up front. Doing the jQuery
    // lookups inside the comparator turns this into O(n log n) DOM traversals,
    // which locks up the main thread on large rosters during presence bursts.
    var items = rows.map(function (row) {
      var $row = $(row);

      return {
        row: row,
        availIndex: $row.data('availindex'),
        onPhone: $row.find('.onphone').length > 0,
        firstName: $row.attr('firstname')
      };
    });

    items.sort(function (a, b) {
      var A = a.availIndex;
      var B = b.availIndex;

      if (A === B) {
        if (A == 'a') {
          if (a.onPhone || b.onPhone) {
            if (a.onPhone && !b.onPhone) {
              return 1;
            }

            if (!a.onPhone && b.onPhone) {
              return -1;
            }
          }
        }

        return caseInsensitiveCompare(a.firstName, b.firstName);
      }

      if (A < B) {
        return -1;
      }

      if (A > B) {
        return 1;
      }

      return 0;
    });

    var sorted = items.map(function (item) {
      return item.row;
    });

    return sortOrder == 'desc' ? sorted.reverse() : sorted;
  };

  /**
   * Compares and sorts entry based on extension
   *
   * @param {object} rows contains all of the row elements to be sorted in the table
   *
   * @private
   * @returns {object} rows is the sorted object of rows
   */
  var sortByExtension = function (rows, sortOrder) {
    // Read sort keys once (see sortByOnline for rationale).
    var items = rows.map(function (row) {
      var $row = $(row);
      var uid = $row.attr('uid');
      var lastName = $row.attr('lastname');

      return {
        row: row,
        uid: uid == null ? '' : uid.toString(),
        lastName: lastName == null ? '' : lastName.toString()
      };
    });

    items.sort(function (a, b) {
      var A = a.uid;
      var B = b.uid;

      if (A === B) {
        return naturalSort(a.lastName, b.lastName);
      }

      // for when it doesn't have a user/extension
      if (A == '') {
        return 1;
      }

      if (B == '') {
        return -1;
      }

      return naturalSort(A, B);
    });

    var sorted = items.map(function (item) {
      return item.row;
    });

    return sortOrder == 'desc' ? sorted.reverse() : sorted;
  };

  /**
   * Compares and sorts entry based on either first name or last name, depending on type parameter
   *
   * @param {object} rows contains all of the row elements to be sorted in the table
   * @param {string} type is either firstname or lastname
   *
   * @private
   * @returns {object} rows is the sorted object of rows
   */
  var sortByName = function (rows, sortOrder, type) {
    log('_sortByName');

    var secondSort = (type == 'firstname' ? 'lastname' : 'firstname');

    // Read sort keys once (see sortByOnline for rationale).
    var items = rows.map(function (row) {
      var $row = $(row);

      return {
        row: row,
        primary: $row.attr(type),
        secondary: $row.attr(secondSort)
      };
    });

    items.sort(function (a, b) {
      var primaryResult = caseInsensitiveCompare(a.primary, b.primary);

      // If primary sort is equal, do secondary sort
      if (primaryResult === 0) {
        return caseInsensitiveCompare(a.secondary, b.secondary);
      }

      return primaryResult;
    });

    var sorted = items.map(function (item) {
      return item.row;
    });

    return sortOrder == 'desc' ? sorted.reverse() : sorted;
  };

  /**
   * Determines if item (table row) should show up in search results
   *
   * @param {string} filter is the Contacts Group that was selected for filter with
   * @param {string} textfilter is the string of text that the user input to search
   * @param {object} thisRow is the row element being checked against the textfilter
   * @returns {boolean} true if the row is visible, false if it isn't
   */
  var isItemViewable = function (filter, textfilter, thisRow) {
    var isViewable = false;

    // This gets flipped from Offline to inactive somewhere, but they're analogous
    if (filter == 'inactive') {
      filter = 'Offline';
    }

    filter = filter.trim();

    if (filter == 'All') {
      isViewable = true;
    } else if (filter == 'My Contacts') {
      if ((typeof (thisRow.attr('uid')) === 'undefined' || thisRow.attr('uid') == '')
        && (thisRow.attr('shared') != 'true'
          && thisRow.attr('shared') != '1')
      ) {
        isViewable = true;
      }
    } else if (filter == 'Favorites') {
      if (typeof (thisRow.attr('fav')) !== 'undefined') {
        if (thisRow.attr('fav') == '1') {
          isViewable = true;
        }
      }
    } else if (filter == 'Coworkers' && thisRow.attr('uid') != '') {
      isViewable = true;
    } else if (filter == 'Available') {
      if (thisRow.attr('presence') == 'open') {
        isViewable = true;
      }
    } else if (filter == 'Offline') {
      if (thisRow.attr('presence') == 'inactive') {
        isViewable = true;
      }
    } else if (filter == 'Busy') {
      if (thisRow.attr('presence') == 'inuse') {
        isViewable = true;
      }

      if (thisRow.attr('presence') == 'closed') {
        isViewable = true;
      }

      if (thisRow.attr('presence') == 'progressing') {
        isViewable = true;
      }

      if (thisRow.attr('presence') == 'alerting') {
        isViewable = true;
      }
    } else if (filter == 'Shared') {
      if (thisRow.attr('shared') == 'true' || thisRow.attr('shared') == '1') {
        isViewable = true;
      }
    } else if (thisRow.attr('department') == filter) {
      isViewable = true;
    } else if (thisRow.attr('site') == filter) {
      isViewable = true;
    }

    if (typeof (textfilter) !== 'undefined'
      && textfilter != 'Enter a name or extension'
      && textfilter != ''
      && textfilter != ' '
    ) {
      // only apply text filter if item is currently visible
      if (isViewable) {
        isViewable = checkTextFilter(textfilter, thisRow);
      }
    }

    return isViewable;
  };

  /**
   * Compares and sorts entry based on presence, extension or name
   *
   * @param {object} rows contains all of the row elements to be sorted in the table
   * @param {string} sortType is the sort type parameter
   * @returns {object} rows is the sorted object of rows
   */
  var sortRows = function (rows, sortType, sortOrder) {
    log('NSPresenceSearchSort.sortRows');

    if (sortType == 'Online') {
      rows = sortByOnline(rows, sortOrder);
    } else if (sortType == 'Extension') {
      rows = sortByExtension(rows, sortOrder);
    } else if (sortType == 'First Name') {
      rows = sortByName(rows, sortOrder, 'firstname');
    } else if (sortType == 'Last Name') {
      rows = sortByName(rows, sortOrder, 'lastname');
    }

    return rows;
  };

  return {
    isItemViewable: isItemViewable,
    sortRows: sortRows
  };
}());

/**
 * NETSAPIENS search and sort contacts module based on NSAgentSearch OMP-56
 * Used in Contacts dock.ctp and popout.ctp
 *
 * @requires jquery-3.0.0.min.js
 * @requires NSPresenceSearchSort module
 * @returns {object} public methods
 */
var NSContactSearch = (function () {
  var sortDebounceTimer = null;
  var sortDebounceDeadline = 0;

  // Wait for a burst to settle before sorting, but never stall longer than the
  // max wait - on a busy domain events can keep arriving inside every debounce
  // window, which would re-arm the timer indefinitely.
  var SORT_DEBOUNCE_MS = 250;
  var SORT_MAX_WAIT_MS = 2000;

  /**
   * filter contacts using the search string.
   *
   * @private
   */
  var resetContacts = function (tableId, reset) {
    var rows = $('#contacts-table > tbody > tr');
    var textFilter = $('#contacts-searchbox-input').val();
    var filter = $('#contact-groups option:selected').val();
    var currentGroup = $('#current-group');
    var viewable = false;
    var thisRow;

    if (typeof tableId === 'undefined') {
      // default is dock contacts
      tableId = 'contacts-table';
    }

    if (typeof reset === 'undefined') {
      reset = false;
    }

    $('#' + tableId + ' .contact-row').hide();

    if (reset) {
      // if it is resetting contacts from exit, need to keep current group selected
      filter = currentGroup.data('selected')
        ? currentGroup.data('selected')
        : currentGroup.text();
    } else if (currentGroup.data('selected')) {
      filter = currentGroup.data('selected');
    }

    rows.each(function (index, row) {
      thisRow = $(row);

      if (NSPresenceSearchSort.isItemViewable(filter, textFilter, thisRow)) {
        thisRow.show();
        viewable = true;
        $('.nonecreated-contacts').hide();
      }
    });

    if (!viewable) {
      var message = $('.nonecreated-contacts h5');

      if (textFilter) {
        message.text(_('No contacts matched your search for') + ' "' + textFilter + '".');
      } else {
        message.text(_('No contacts found.'));
      }

      $('.nonecreated-contacts').show();
    }
  };

  /**
   * sort contacts table based on selected sort option
   *
   * @private
   */
  var sortContactsTable = function (actionsId, tableId) {
    if (typeof actionsId === 'undefined') {
      // default is dock contacts
      actionsId = 'contacts-sort-search';
    }

    if (typeof tableId === 'undefined') {
      // default is dock contacts
      tableId = 'contacts-table';
    }

    log('NSContactSearch.sortContactsTable');

    var rows = $('#' + tableId + ' .contact-row').get();
    var sortType = Storages.localStorage.get('contacts_sort_type_' + actionsId);
    var sortOrder = Storages.localStorage.get('contacts_sort_order_' + actionsId);

    if (sortType == null) {
      sortType = 'Extension';
    }

    if (sortOrder == null) {
      sortOrder = 'asc';
    }

    rows = NSPresenceSearchSort.sortRows(rows, sortType, sortOrder);

    // Re-append the sorted rows in a single DOM operation. Appending row by row
    // forces a reflow per row, which is prohibitively slow on large rosters.
    var tbody = $('#' + tableId).children('tbody')
      .get(0);

    if (tbody) {
      var fragment = document.createDocumentFragment();

      rows.forEach(function (row) {
        fragment.appendChild(row);
      });

      tbody.appendChild(fragment);
    }
  };

  /**
   * bind listeners for sortings, search string entry, and show/hide toggle of search field
   *
   * @private
   */
  var bindUIActions = function (actionsId, tableId) {
    log('NSContactSearch.bindUIActions');

    var $inputBox = $('#' + actionsId + ' .contacts-searchbox-input');
    var $searchBox = $('#' + actionsId + ' .contacts-searchbox');
    var $searchDropToggle = $('#' + actionsId + ' .contacts-sort-dropdown .dropdown-toggle');
    var $searchBoxIcon = $('#' + actionsId + ' .contacts-searchbox-icon span');

    var isOpen = false;

    /* select sort option */
    $('#' + actionsId + ' .contacts-sortby-toggle a').on('click', function () {
      var sortTypeText = $(this).text();
      var sortType = $(this).data('contacts-sort-type');
      var sortOrder = $(this).data('contacts-sort-order');
      var previousSortType = Storages.localStorage.get('contacts_sort_type_' + actionsId);
      var previousSortOrder = Storages.localStorage.get('contacts_sort_order_' + actionsId);

      if (previousSortType == sortType) {
        // reverse order when sorting by same type
        sortOrder = previousSortOrder == 'desc' ? 'asc' : 'desc';
      }

      Storages.localStorage.set('contacts_sort_type_' + actionsId, sortType);
      Storages.localStorage.set('contacts_sort_order_' + actionsId, sortOrder);
      $('#' + actionsId + ' .contacts-current-sortby').text(sortTypeText);

      sortContactsTable(actionsId, tableId);

      return true;
    });

    // read search string after each key press
    $inputBox.on('keyup', function () {
      resetContacts();
    });

    // toggle the search field
    $('#' + actionsId + ' .contacts-searchbox-icon').on('click', function () {
      if (isOpen == false) {
        $searchBox.addClass('searchbox-open');
        $inputBox.trigger('focus');
        $searchDropToggle.fadeTo('fast', 0);
        $searchBoxIcon.removeClass('iconfont-search').addClass('iconfont-remove');

        // set height of scroll container so it doesn't shift when searching
        $('.dock-contacts .scroll-container').css('height', function () {
          return $(this).height() + 'px';
        });

        isOpen = true;
      } else {
        $searchBox.removeClass('searchbox-open');
        $inputBox.attr('placeholder', '')
          .val('')
          .trigger('focusout');
        $searchDropToggle.fadeTo('fast', 1);
        $searchBoxIcon.removeClass('iconfont-remove').addClass('iconfont-search');
        resetContacts(undefined, true);

        // remove height of scroll container
        $('.dock-contacts .scroll-container').css('height', '');

        isOpen = false;
      }
    });
  };

  var changedGroup = function (actionsId) {
    resetContacts();

    var filter = $('#' + actionsId + ' .contact-groups option:selected').val();

    // brought cookie saving over from existing function in node.php
    Cookies.set('Dock_filter', filter, { expires: 365, path: '/' });
  };

  /**
   * after receiving a socket update for contacts, check if user is currently
   * searching their contacts so we don't resort/reset the table.
   * if they're not searching, sort the table
   */
  var receivedSocketUpdate = function () {
    // updates only go to dock
    var actionsId = 'contacts-sort-search';
    var searchOpen = $('.contacts-searchbox').hasClass('.searchbox-open');
    var sortType = Storages.localStorage.get('contacts_sort_type_' + actionsId);

    // only sort from socket update if searchbox isn't open and sort type is Online
    if (searchOpen || sortType != 'Online') {
      return;
    }

    // Coalesce a burst of presence updates (e.g. the flood received right after
    // subscribing to a large domain) into a single sort once the burst settles,
    // instead of re-sorting on every event.
    var now = Date.now();

    // First event of a burst - start the max-wait clock.
    if (!sortDebounceTimer) {
      sortDebounceDeadline = now + SORT_MAX_WAIT_MS;
    }

    clearTimeout(sortDebounceTimer);

    sortDebounceTimer = setTimeout(function () {
      sortDebounceTimer = null;
      sortContactsTable();
    }, Math.min(SORT_DEBOUNCE_MS, Math.max(0, sortDebounceDeadline - now)));
  };

  /**
   * initialize NSAgentSearch
   */
  var init = function (actionsId, tableId) {
    // Get localStorage sort_type value
    var local = Storages.localStorage.get('contacts_sort_type_' + actionsId);

    // Set sortType value if local falsy or undefined "Last Name", else local value
    var sortType = (!local || typeof local === 'undefined') ? 'Last Name' : local;

    // Translate and display sortType
    var sortTypeText = $('#' + actionsId + ' .contacts-sortby-toggle')
      .find('[data-contacts-sort-type="' + sortType + '"]')
      .text();

    $('#' + actionsId + ' .contacts-current-sortby').text(sortTypeText);

    resetContacts(tableId);
    sortContactsTable(actionsId, tableId);
    bindUIActions(actionsId, tableId);
  };

  return {
    init: init,
    receivedSocketUpdate: receivedSocketUpdate,
    changedGroup: changedGroup,
    resetContacts: resetContacts
  };
}());

/**
 * ModalTabs
 * This module initializes tabs in a modal by customizing behavior
 * Requires tab markup to exist before initializing. See domains/write.ctp for example
 *
 * @return public entry to init method.
 */
var ModalTabs = (function () {
  /**
   * local settings variables accessible across module methods
   */
  var s = {
    $form: null,
    isAdd: false
  };

  var f = {
    $form: null,
    isAdd: false
  };

  /**
   * binds events
   *
   * @private
   */
  var bindUIActions = function () {
    // prevent default tab behavior by removing
    $('.modal').off('click.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]');

    // manually handle tab click events for validation
    $('.modal-nav-tabs a').off()
      .on('click', function (e) {
        e.preventDefault();

        if (s.$form.length == 0) {
          console.log('Form invalid, re running init');
          // eslint-disable-next-line no-use-before-define
          init();
        }

        // validate form before showing another tab
        if (s.$form.validationEngine('validate')) {
          $(this).tab('show');
        }
      });

    // if adding, show "next" and "back" buttons. bind behavior accordingly
    if (s.isAdd) {
      $('.modal-tabs-btn-next').on('click', function () {
        // validate form before showing next tab
        if (s.$form.length == 0) {
          console.log('Form invalid, re running init');
          // eslint-disable-next-line no-use-before-define
          init();
        }

        // if it is domain add, validate the address in the form
        if ($('.address_line_1_domain_add').is(':visible')) {
          // set IP address of where the user is at here
          var publicIp;

          $.get('/portal/publicip.php', function (response) {
            publicIp = response.ip;

            $.post('/portal/inventory/validateAddress2', $('#write-domain-form').serialize())
              .done(function (data) {
                var json = JSON.parse(data);

                if (json['address']['valid'] == true) {
                  // address was valid
                  // set save to be enabled
                  // $('.saveBtn').prop('disabled', false);

                  // stringify the json of json['address']['standardized'] and set it to a value above
                  var standardizedString = JSON.stringify(json['address']['standardized']);

                  // set standardized in the form, hidden field but still used in database
                  document.getElementById('stardardized').value = standardizedString;
                  // set carrier in the form, hidden field but still used in database
                  document.getElementById('carrier').value = json['address']['carrier'];
                  document.getElementById('public_ip').value = publicIp;

                  $('#validate-address-message')
                    .addClass('text-success')
                    .text(_('The address has been confirmed and any suggested changes have been applied.'));

                  jsFlash(_('Address was valid!'), 'success');
                  if (s.$form.validationEngine('validate')) {
                    $('.modal-nav-tabs .active').next('li:visible').children('a').tab('show');
                  }

                } else {
                  // address was not valid
                  // show the address is not valid alert
                  jsFlash(_('Address was not valid!'), 'error');
                }
              });
          }, 'json').fail(function () {
            setTimeout(function () {
              $('.valBtn')
                .prop('disabled', false)
                .button('reset');

              $('#validate-address-message')
                .addClass('text-error')
                .text(_('Unable to validate address, please check browser plug-ins and setting.'));
            }, 1000);
          });
        } else {
          if (s.$form.validationEngine('validate')) {
            $('.modal-nav-tabs .active').next('li:visible').children('a').tab('show');
          }
        }
      });

      $('.modal-tabs-btn-back').on('click', function () {
        // validate form before showing previous tab
        if (s.$form.validationEngine('validate')) {
          $('.modal-nav-tabs .active').prev('li')
            .children('a')
            .tab('show');
        }
      });

      $('.modal-nav-tabs a').on('shown.bs.tab', function () {
        var $currentTab = $(this).parent();
        var $nextBtn = $('.modal-tabs-btn-next');
        var $backBtn = $('.modal-tabs-btn-back');
        var $saveBtn = $('.modal-tabs-btn-save');

        // show and hide 'add' and 'back' buttons if adding
        // hide 'next' button if on the final tab. show save button instead.
        if ($currentTab.is(':last-child')) {
          $nextBtn.hide();
          $saveBtn.show();
        } else {
          $nextBtn.show();
          $saveBtn.hide();
        }

        // hide 'back' button if on the first tab.
        if ($currentTab.is(':first-child')) {
          $backBtn.hide();
        } else {
          $backBtn.show();
        }
      });
    }

    if (f.isAdd) {
      $('.modal-tabs-btn-next-cdr').on('click', function () {
        // validate form before showing next tab
        if (f.$form.length == 0) {
          console.log('f.$form.length == 0');
          // eslint-disable-next-line no-use-before-define
          init();
        }

        if (f.$form.validationEngine('validate')) {
          // ajax 200 error
          $('.modal-nav-tabs .active').next('li:visible')
            .children('a')
            .tab('show');
        }
      });

      // when clicking on back button
      $('.modal-tabs-btn-back-cdr').on('click', function () {
        // validate form before showing previous tab
        $('.modal-nav-tabs .active').prev('li')
          .children('a')
          .tab('show');
      });

      $('.modal-nav-tabs a').on('shown.bs.tab', function () {
        var $currentTab = $(this).parent();
        var $nextBtn = $('.modal-tabs-btn-next-cdr');
        var $backBtn = $('.modal-tabs-btn-back-cdr');
        var $saveBtn = $('.modal-tabs-btn-save');
        var $title = $('#modal-title');

        // show and hide 'add' and 'back' buttons if adding
        // hide 'next' button if on the final tab. show save button instead.
        if ($currentTab.is(':last-child')) {
          $nextBtn.hide();
          $saveBtn.show();
        } else {
          $nextBtn.show();

          if (!$title.text().includes('Edit')) {
            // should not affect anything but CDR Schedule,
            // but if it does find a different way CDR-149
            $saveBtn.hide();
          }
        }

        // hide 'back' button if on the first tab.
        if ($currentTab.is(':first-child')) {
          $backBtn.hide();
        } else {
          $backBtn.show();
        }
      });
    }
  };

  /**
   * initializes
   * @param {string} id is the id of the form that must be validated before switching tabs
   * @param {boolean}
   */
  var init = function () {
    s.$form = $('.modal.in').find('form');

    // determine if next and back buttons should be shown
    if ($('.modal-tabs-btn-next').length) {
      s.isAdd = true;
    }

    f.$form = $('.modal.in').find('form');

    // determine if next and back buttons should be shown
    if ($('.modal-tabs-btn-next-cdr').length) {
      f.isAdd = true;
    }

    bindUIActions();
  };

  /**
   * public methods
   */
  return {
    init: init
  };
}());

/**
 * NSDomainSettings
 * Everything to do with the Edit Domain Settings (domains/write.ctp) including the
 * Edit Settings button in the domain message header.
 *
 * @requires dateformat
 * @return public entry to methods.
 */
var NSCdrScheduleSettings = (function () {
  /**
   * local settings variables accessible across module methods
   */
  var s = {
    modalId: '#write-domain'
  };

  var f = {
    modalId: '#cdr-scheduling'
  };

  /**
   * binds events
   *
   * @private
   */
  var bindUIActions = function () {
    // initialize navigation tabs
    ModalTabs.init();
  };

  // upon change of the calendar, disable or enable the "Also run this export immediately"
  var startTimeChange = function (value) {
    var valueDate = moment(value);

    // null out the run immediately if the date is in the future
    if (valueDate.isSameOrBefore(moment.now())) {
      document.getElementById('CdrScheduleRunImmediately').disabled = true;
      $('#CdrScheduleRunImmediately').prop('checked', false);
    } else {
      document.getElementById('CdrScheduleRunImmediately').disabled = false;
    }
  };

  var capturePeriodChange = function (value) {
    var userTimeFormat;

    if (value == '1 month' || value == '3 months' || value == '6 months') {
      // if month is chosen, need to block out the 28-31st
      var array = [29, 30, 31];

      userTimeFormat = 'hh:mm tt';

      if ($('.cdrScheduleCalendar').data('time-format') == 'HH:mm') {
        userTimeFormat = 'HH:mm';
      }

      $('.cdrScheduleCalendar').datetimepicker('destroy');
      $('.cdrScheduleCalendar').datetimepicker({
        showMinute: true,
        showHour: true,
        dateFormat: 'dd/mm/yyyy',
        timeFormat: userTimeFormat,

        onSelect: function () {
          $('[id=' + this.id + ']').val(NSCdrScheduleSettings.formatDate(this.value));
        },

        beforeShowDay: function (date) {
          var number = date.getDate();

          return [array.indexOf(number) === -1];
        }
      })
        .datetimepicker(
          'setDate',
          (document.getElementsByClassName('cdrScheduleCalendar')[0].value)
        );
    } else {
      // reset the datetimepicker back to regular
      userTimeFormat = 'hh:mm tt';

      if ($('.cdrScheduleCalendar').data('time-format') == 'HH:mm') {
        userTimeFormat = 'HH:mm';
      }

      $('.cdrScheduleCalendar').datetimepicker('destroy');
      $('.cdrScheduleCalendar').datetimepicker({
        showMinute: true,
        showHour: true,
        dateFormat: 'dd/mm/yyyy',
        timeFormat: userTimeFormat,
        onSelect: function () {
          $('[id=' + this.id + ']').val(NSCdrScheduleSettings.formatDate(this.value));
        }
      })
        .datetimepicker('setDate', document.getElementsByClassName('cdrScheduleCalendar2')[0].value);
    }
  };

  var cdrFormatChange = function (value) {
    if (value == 'Advanced') {
      $('.format_note')
        .text(_('This format exports with the more common fields of a call\'s history') + '.');
    } else if (value == 'Standard') {
      $('.format_note').text(_('This format exports with all the fields of a call\'s history')
        + '.');
    } else {
      $('.format_note').text(_(
        'This format exports with the fields used in the previous call history export'
      ) + '.');
    }
  };

  var checkBoxChange = function (value) {
    if (value === true) {
      $('#CdrScheduleEmail').addClass('validate[required]');
    } else {
      $('#CdrScheduleEmail').removeClass('validate[required]');
    }
  };

  var formatDate = function (date) {
    return moment(date).format('MM/DD/YYYY hh:mm a');
  };

  var swapDate = function (date) {
    return moment(date).format('DD/MM/YYYY hh:mm a');
  };

  var extraExportArguments = function (value) {
    // logic for SFTP and FTP changes in modal
    if (value === 'sftp' || value === 'ftp upload') {
      $('.exportCredentials').show(600);
      $('#CdrScheduleEmail').removeClass('validate[required]');
    } else {
      $('.exportCredentials').hide(600);
    }

    var sendEmailOriginal = $('#send_email_original');
    var sendEmailDisabled = $('#send_email_disabled');

    // logic for email specific changes in modal
    if (value == 'email') {
      sendEmailOriginal.prop('checked', true);
      $('#CdrScheduleEmail').addClass('validate[required]');
      sendEmailOriginal.closest('.checkbox').hide();
      sendEmailDisabled.closest('.checkbox').show();
    } else {
      // enable the checkbox again
      $('#CdrScheduleSendEmail').prop('disabled', false);
      sendEmailOriginal.closest('.checkbox').show();
      sendEmailDisabled.closest('.checkbox').hide();
    }
  };

  var checkEmailNotification = function (value) {
    // if value contains some letters (not blank or all spaces), then check, else will uncheck
    document.getElementById('send_email_original').checked = !!value.match(/[a-z]/i);
  };

  /**
   * toggle custom recording limits fields
   *
   */
  var customRecLimits = function () {
    console.log('in customRecLimits after change');

    $('#extraExportFields').show();
  };

  /**
   *
   * @param {object} btn is the DOM element object of the settings button
   */
  var clickedSettingsButton = function (btn) {
    log('clickedSettingsButton');

    var modalPath = $(btn).data('modal-path');
    // check if settings modal is visible
    var justHide = $(s.modalId).hasClass('in');

    // check if any modal is visible and hide it
    if (NSModal.isModalVisible()) {
      $('.modal').modal('hide');
    }

    // show and load domain settings modal if it wasn't visible already
    if (!justHide) {
      $(s.modalId).modal('show');
      loadModal(s.modalId, modalPath);
    }
  };

  // update domain description in the header after submitting
  var updateHeaderDesc = function () {
    var newDesc = $('#DomainDescription').val();

    $('.domain-description').text(newDesc);
  };

  /**
   * initializes
   */
  var init = function () {
    // set modal to a pleasing height so it doesn't shift modal size when switching between tabs
    var maxHeight = parseFloat($(f.modalId + ' .modal-body').css('maxHeight'));

    // approximate height of tallest tab in the modal
    var fixedHeight = 450;

    if (maxHeight > fixedHeight) {
      maxHeight = fixedHeight;
    }

    $(f.modalId + ' .modal-body').css('height', maxHeight + 'px');
    bindUIActions();
  };

  /**
   * public methods
   */
  return {
    init: init,
    customRecLimits: customRecLimits,
    clickedSettingsButton: clickedSettingsButton,
    extraExportArguments: extraExportArguments,
    checkEmailNotification: checkEmailNotification,
    updateHeaderDesc: updateHeaderDesc,
    startTimeChange: startTimeChange,
    capturePeriodChange: capturePeriodChange,
    formatDate: formatDate,
    swapDate: swapDate,
    checkBoxChange: checkBoxChange,
    cdrFormatChange: cdrFormatChange
  };
}());

/**
 * NSDomainSettings
 * Everything to do with the Edit Domain Settings (domains/write.ctp) including the
 * Edit Settings button in the domain message header.
 *
 * @return public entry to methods.
 */
var NSDomainSettings = (function () {
  /**
   * local settings variables accessible across module methods
   */
  var s = {
    modalId: '#write-domain'
  };

  /**
   * binds events
   *
   * @private
   */
  var bindUIActions = function () {
    // initialize navigation tabs
    ModalTabs.init();
  };

  /**
   * toggle custom recording limits fields
   *
   */
  var customRecLimits = function () {
    if ($('#custom_limits').prop('checked')) {
      $('#defaultRecordingSection').hide();
      $('#domainRecordingSection').show();
    } else {
      $('#domainRecordingSection').hide();
      $('#defaultRecordingSection').show();
    }
  };

  /**
   *
   * @param {object} btn is the DOM element object of the settings button
   */
  var clickedSettingsButton = function (btn) {
    log('clickedSettingsButton');

    var modalPath = $(btn).data('modal-path');
    // check if settings modal is visible
    var justHide = $(s.modalId).hasClass('in');

    // check if any modal is visible and hide it
    if (NSModal.isModalVisible()) {
      $('.modal').modal('hide');
    }

    // show and load domain settings modal if it wasn't visible already
    if (!justHide) {
      $(s.modalId).modal('show');
      loadModal(s.modalId, modalPath);
    }
  };

  // update domain description in the header after submitting
  var updateHeaderDesc = function () {
    var newDesc = $('#DomainDescription').val();

    $('.domain-description').text(newDesc);
  };

  /**
   * initializes
   */
  var init = function () {
    // set modal to a pleasing height so it doesn't shift modal size when switching between tabs
    var maxHeight = parseFloat($(s.modalId + ' .modal-body').css('maxHeight'));
    // approximate height of tallest tab in the modal
    var fixedHeight = 380;

    if (maxHeight > fixedHeight) {
      maxHeight = fixedHeight;
    }

    $(s.modalId + ' .modal-body').css('height', maxHeight + 'px');
    console.log('maxheight for domain is: ' + maxHeight);
    bindUIActions();
  };

  /**
   * public methods
   */
  return {
    init: init,
    customRecLimits: customRecLimits,
    clickedSettingsButton: clickedSettingsButton,
    updateHeaderDesc: updateHeaderDesc
  };
}());

/**
 * ModuleTemplate
 * This module is a template
 *
 *
 * @return public entry to init method.
 */
var ModuleTemplate = (function () {
  /**
   * binds events
   */
  var bindUIActions = function () {
    // Do nothing
  };

  /**
   * initializes
   */
  var init = function () {
    bindUIActions();
  };

  /**
   * public methods
   */
  return {
    init: init
  };
}());
